import { useConsentStore } from '@/consent/consentStore'
import { CookieBanner } from './CookieBanner'

/**
 * CookieBannerProvider — слот в App, рендерит CookieBanner если bannerVisible=true.
 * Видимость управляется bootstrapConsent (показывает баннер если нет stored consent).
 */
export function CookieBannerProvider() {
  const visible = useConsentStore((s) => s.bannerVisible)
  if (!visible) return null
  return <CookieBanner />
}
